import React from 'react';

function BankTransfer(props) {
  return (
    <div className="bank-transfer font11">
      <div className="step">
        <div className="number">1</div>
        <div className="text">{props.t('PROFILE.TRANSFER_RECHARGE_AMOUNT')}</div>
      </div>
      <div className="details">
        <div className="flex-row">
          <div className="label">{props.t('PROFILE.RECIPIENT')}:</div>
          <div className="value">PasajeBus Spa</div>
        </div>
        <div className="flex-row">
          <div className="label">RUT:</div>
          <div className="value">76.335.837-2</div>
        </div>
        <div className="flex-row">
          <div className="label">{props.t('PROFILE.BANK')}:</div>
          <div className="value">BancoEstado</div>
        </div>
        <div className="flex-row">
          <div className="label">{props.t('PROFILE.BANK_ACCOUNT')}:</div>
          <div className="value">20400001538</div>
        </div>
        <div className="flex-row">
          <div className="label">{props.t('PROFILE.EMAIL_ID')}:</div>
          <div className="value">pbcash@pasajebus.com</div>
        </div>
      </div>
      <div className="step">
        <div
          className="number"
          // style={{ animation: 'blinking 1s infinite' }}
        >
          2
        </div>
        <div className="text secondary-text bold-text">{props.t('PROFILE.RUT_DEST_ACC')}</div>
      </div>
    </div>
  );
}

export default BankTransfer;



// WEBPACK FOOTER //
// ./src/features/my-account/RechargeWalletKupospayRecharge/components/BankTransfer.js